module.exports = __webpack_public_path__ + "static/logo-white-57d4875fd70bc82293debc37f12fb3ee.png";